import React from 'react';
import ReactDOM from 'react-dom';
import { configureStore } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Provider } from 'react-redux';
import { connect } from 'react-redux';
import validator from "validator";
import FormError from "../../../FormError";
import Modal from '../../../Modal';
import { addEmailKeywordRecipient, removeEmailRecipient, updateModalContent } from '../../../redux/FeedbackRedux';



class KeywordEmailRecipients extends React.Component {
  constructor(props) {
    super(props);
    this.state = { email: "", name: "" };

    this.handleAddEmailRecipient = this.handleAddEmailRecipient.bind(this);
  }

  handleSelectExisting(){
    var modal_id = "addExistingSMSRecipient";
    var modal_title =  __("Email Recipients");
    var modal_body = "potentialRecipientsEmail";
    var button_1_class = "outline-secondary";
    var button_1_id = "cancel";
    var button_1_text =  __("Cancel");
    var button_2_class = "primary d-none";
    var button_2_id = "none";
    var button_2_text = "none";
    this.props.dispatch(updateModalContent({modal_id:modal_id,modal_title:modal_title,modal_body:modal_body,button_1_class:button_1_class,button_1_id:button_1_id,button_1_text:button_1_text,button_2_class:button_2_class,button_2_id:button_2_id,button_2_text:button_2_text}));
    jQuery('.modal:not(.error)').modal();
  }

  handleAddEmailRecipient(event) {
    var email = this.state.email;
      if (!email || !validator.isEmail(email)) {
        this.setState({ email_error:  __("Please enter a valid email address.") });
        return;
      }
      var email_map = this.props.email_recipients.map((item, key) => item.email);
      if (email_map.includes(this.state.email)) {
        this.setState({
          email_error:  __("This email address is already in the list.")
        });
        return;
      }

    this.props.dispatch(addEmailKeywordRecipient(this.state));

    this.setState({ email: "", name: "" , email_error:false});
  }

  handleRemoveEmailRecipient(uuid, event){
      event.preventDefault();
    this.props.dispatch(removeEmailRecipient({"uuid":uuid}));
    $('button[type=submit]').removeAttr('disabled');
  }

  render() {
    return (
      <div className="card">
        <div className="title px-3 py-3">
          <h5 className="d-flex align-items-center mb-3"><span>{ __('Emails') }:</span> <span className="ml-auto btn btn-sm btn-secondary btn-outline-primary" onClick={this.handleSelectExisting.bind(this)}>{ __('Add Existing User') }</span></h5>
          <p className="">
            { __('Users can receive an email whenever Feedbacks or chat messages with certain keywords are submitted for this business. The text will include the keywords used, along with a link to view the Feedback.') }
          </p>

          <div className="row mt-3 card-body">
            <div className="col-sm-6 px-2">
              <div className="input-group feedback-form-control mb-2">

                <input
                  placeholder={ __('Email Address') }
                  type="email"
                  className="form-control input"
                  name="recipient_email"
                  value={this.state.email}
                  onChange={event =>
                    this.setState({ email: event.target.value })
                  }
                  onKeyPress={e => {if(e.key === "Enter"){e.preventDefault();this.handleAddEmailRecipient();}}}
                ></input>
              </div>
              <FormError error_message={this.state.email_error}></FormError>
            </div>

            <div className="col-sm-6 px-2">
              <div className="input-group feedback-form-control mb-2">
                <input
                  placeholder={ __('Recipient First and Last Name') }
                  type="text"
                  className="form-control input"
                  name="name"
                  value={this.state.name}
                  onChange={event =>
                    this.setState({ name: event.target.value })
                  }
                  onKeyPress={e => {if(e.key === "Enter"){e.preventDefault();this.handleAddEmailRecipient();}}}
                ></input>
              </div>
            </div>


          </div>
        <div className='d-flex justify-content-between filter-bar-wrapper-reverse'>
            <h5>{__('Email Address List: (click on a contact to remove them from the list)')}</h5>
            <a
                className="btn btn-sm btn-primary text-white d-inline-block mb-1"
                onClick={this.handleAddEmailRecipient}
              >
                <i className="fas fa-inbox-in mr-1"></i> { __('Add Email Address To List') }
              </a>
          </div>
          <div className="row">
            <div className="col-sm-12">
              {this.props.email_recipients.map((item, key) => (
                <div className="d-inline-block mr-2 mb-2" key={item.uuid}>

                    <a
                      href=""
                      className="btn btn-outline-primary btn-sm"
                      onClick={this.handleRemoveEmailRecipient.bind(
                        this,
                        item.uuid
                      )}
                    >
                      <i
                        className="fas fa-user-times mr-1"
                        aria-hidden="true"
                      ></i>{" "}
                      {item.email}{" "}
                      {item.recipient_name ? "(" + item.recipient_name + ")" : ""}
                    </a>
                  </div>

              ))}

              {this.props.email_recipients.length == 0 ? (
                <div>{ __('Empty') }</div>
              ) : (
                <div></div>
              )}
            </div>
          </div>

        </div>
        <input
          type="hidden"
          name="email_recipients"
          value={JSON.stringify(this.props.email_recipients)}
        ></input>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        email_recipients: state.email_recipients
    }
}

export default connect(mapStateToProps)(KeywordEmailRecipients)
